export enum AutomationRequestStatus {
	Requested,
	Approved,
	Rejected,
	InProgress,
	Ready,
	Failed,
	Deleted,
}
